module.exports = __webpack_public_path__ + "04baf98dff8005b6919948e61b4a247b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/tiaa_investments_nuveen.png
// module id = 1748
// module chunks = 0